// extracted by mini-css-extract-plugin
export var dividerLine = "_7w-3";
export var itemImage = "_7w-9";
export var lightDivider = "_7w-4";
export var modalContent = "_7w-5";
export var modalContentCompact = "_7w-6";
export var productCard = "_7w-a";
export var productImage = "_7w-b";
export var productImageCompact = "_7w-7";
export var productImagePlaceholder = "_7w-c";
export var productImagePlaceholderCompact = "_7w-8";
export var progressBarBackground = "_7w-1";
export var progressBarContainer = "_7w-0";
export var progressBarFill = "_7w-2";